import React, { useEffect, useState } from "react";
import RightTimeApi from "@/API";
import { appendBillingOrgQuery } from "@/utils/billingOrgHelpers";
import { FaPlusSquare } from "react-icons/fa";
import Helpers from "@/Helpers";


export default function AccruingInvoicesTab({ isActive, processInvoiceAsync, formatCurrency, updateSpinner, refreshKey, billingOrgId = 0 }) {
  const [accruingInvoices, setAccruingInvoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isActive) fetchAccruingInvoices();
  }, [isActive, refreshKey, billingOrgId]);

  async function fetchAccruingInvoices() {
    setLoading(true);
    setError(null);
    updateSpinner && updateSpinner(true);
    try {
      const resp = await RightTimeApi.getAsync(appendBillingOrgQuery("/Invoices/Accruing", billingOrgId));
      if (resp && resp.ok && resp.jsonData) {
        setAccruingInvoices(resp.jsonData);
      } else {
        setError("Failed to load accruing invoices");
      }
    } catch (error) {
      setError("Error loading accruing invoices: " + error.message);
    } finally {
      setLoading(false);
      updateSpinner && updateSpinner(false);
    }
  }

  return (
    <div className="horizontal">
      <div className="tableWrapper dimensionTable scrollable collapsable collapsed">
        <table>
          <caption>
            <span className="title">Invoices Accruing</span>{accruingInvoices ? (
              <>
                <span className="captionCount">({accruingInvoices.length.toString()})</span>
                <span className="captionRight"></span>
              </>
            ) : null}
          </caption>
          <thead>
            <tr>
              <th>Billing Org</th>
              <th>Company</th>
              <th>Period Start</th>
              <th>Period End</th>
              <th>Current Amount</th>
              <th>Item Count</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {accruingInvoices.length > 0 ? (
              accruingInvoices.map((invoice) => (
                <tr key={invoice.id}>
                  <td>{invoice.billingOrgName || ""}</td>
                  <td>{invoice.companyName}</td>
                  <td>{Helpers.formatDate(invoice.periodStart)}</td>
                  <td>{Helpers.formatDate(invoice.periodEnd)}</td>
                  <td className="right">{formatCurrency(invoice.currentAmount)}</td>
                  <td className="center">{invoice.itemCount}</td>
                  <td className="actions">
                    <button onClick={() => processInvoiceAsync(invoice.id, 'generate', invoice.companyId)} className="action generate" title="Generate Invoice">Generate Invoice</button>
                    <button onClick={() => processInvoiceAsync(invoice.id, 'preview', invoice.companyId)} className="action preview" title="Preview Invoice">Preview</button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7} className="center">No accruing invoices found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}


